<template>
  <artmisads-modal  v-model:open="visible" :width="720" :maskClosable="false" :closable="false" :closeIcon="false"
    :footer="null" :header="false" :bodyStyle="{ padding: '0' }" class="link-bonus-modal">
    <div class="modal-content-container">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-header-title">
          <p>New Feature Update !</p>
        </div>
        <svg-icon class="icon-app" name="close-cu" @click="handleClose"/>
      </div>
      <div class="modal-body">
        <p class="title">Dear Amazon Seller</p>
        <div class="description">
          <div class="description-top">
            <span class="dot">·</span>
             Product management is now split into independent
          </div>
        
         <div class="bottom-box">
       
          <div class="item">
                  <img src="../../../../assets/images/img/AT@2x.png" alt="" class="icon">
                  <span class="item-text">Amazon Attribution</span>
          </div>
          and
          <div class="item">
                  <img src="../../../../assets/images/img/AS@2x.png" alt="" class="icon">
                  <span class="item-text">Amazon Associate</span>
           </div>
           programs.
         </div>
        </div>
        <div class="description">
           <div class="description-mid">
            <span class="dot">·</span>A product can have separate activation statuses across different programs, allowing for independent management.
           </div>
        
        </div>
         <div class="description">
             <div class="description-top">
            <span class="dot">·</span>
             <span style="font-weight: 600;">Product discounts will remain synchronized across both.</span>  
          </div>
        </div>
        <div class="footer-btns">
          <artmisads-button :loading="loading" type="primary" class="get-start-btn" @click="handleGetStart">Get Started</artmisads-button>
        </div>
      </div>
    </div> 
  
      <!-- <div class="learn-more">
        <a href="javascript:;" @click="handleLearnMore">Learn more about our bonus program</a>
      </div> -->
    </div>
  </artmisads-modal>
</template>

<script setup>
import i18n from '~/i18n'

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { adminApi } from '../../../../server/index'
import jwt from 'jsonwebtoken';
import { useUserInfoStore } from '../../../../storeData/index';
import SvgIcon from '~/components/SvgIcon.vue'

const store = useUserInfoStore();
const checked = ref(false)
const router = useRouter()
const visible = ref(false)
const emit = defineEmits(['close'])
const loading = ref(false)
const handleClose = async () => {
  visible.value = false
  if(checked.value){
    try {
    const res = await adminApi.associateCompleted()
    const { success, error, data } = res;
    if (success) {
      const userToken = data.token;
      const userInfo = jwt.decode(userToken);
      const menus = store.userInfo.menus;
      store.setUserInfo(userInfo,userToken,menus);
      visible.value = false
     } else {
      message.error(error)
    }
  } catch (err) {
    console.error('Error:', err);
    message.error(i18n.global.t('seller.msg.operationFailed'))
  }
  }
}

const handleGetStart = async () => {
  loading.value = true

    try {
    const res = await adminApi.attributionAssociateSplitCompleted()
    const { success, error, data } = res;
    if (success) {
      const userToken = data.token;
      const userInfo = jwt.decode(userToken);
      const menus = store.userInfo.menus;
      store.setUserInfo(userInfo,userToken,menus);
      visible.value = false
  
      
    } else {
      message.error(error)
    }
  } catch (err) {
    console.error('Error:', err);
    message.error(i18n.global.t('seller.msg.operationFailed'))
  }
 
  
  loading.value = false
  emit('close')
}

const showModal = () => {
  visible.value = true
}

defineExpose({
  showModal
})
</script>

<style scoped lang="less">
.bottom-box{
  display: flex;
  align-items: center;
  margin-top: 4px;
   color: #0f0629;
        font-family: "PingFang SC";
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
      
}
.item:nth-child(2){
  margin: 0 4px;
}
.item:nth-child(1){
 
  margin-left: 0;
  margin-right: 4px;
}
  .item {
    display: flex;
    padding: 3px 4px;
    align-items: center;
    gap: 6px;
    border-radius: 6px;
    background: #F1F0F5;
   
    .icon {
      width: 20px !important;
      height: 20px !important;
    }

    .item-text {
      color: #0f0629;
      font-family: "Sora";
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      letter-spacing: 0.3px;
      opacity: 0.7;
    }
  }
.link-bonus-modal {
  :deep(.artmisads-modal-content) {
    border-radius: 8px;
    overflow: hidden;
    padding: 24px;
   
    background-image: url('../../../../assets/images/home/linkBonus.png') !important;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .modal-content-container{
   
    overflow: hidden;
  }
  

  
  .modal-footer {
    text-align: center;
   margin-top: -20px;
   padding-bottom: 18px;
  }
  .modal-content {
    height: 449px;
    text-align: left;
    background-image: url('../../../../assets/images/home/linkBonus.png') !important;
    background-size: 100% 100%;
    background-repeat: no-repeat;
     width:720px;
    .modal-header {
      position: relative;
      .icon-app{
        position: absolute;
        right: 24px;
        top: 24px;
        font-size: 24px;
        cursor: pointer;
      }
      .modal-header-title {
        color: #0f0629;
        font-family: "Sora";
        font-size: 32px;
        font-style: normal;
        font-weight: 600;
        padding: 24px 40px;
        letter-spacing: 0.69px;
      }
    }

    .modal-body {
      border-radius: var(--Radius-Radius-10, 10px);
      padding: 20px 30px;
      margin: 0 40px;
      border: 1px solid #FFF;
      background: #FFF;
      box-shadow: 0 1px 4px 0 #0000000a, 0 2px 16px 0 #00000014;
     
      .title {
        color: #0f0629;
        font-family: "Sora";
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        margin-bottom: 12px;
      }

      .description {
        color: #0f0629;
        font-family: "PingFang SC";
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        margin-bottom: 20px;
        .dot{
          font-size: 16px;
          font-weight: 500;
        }
        .description-top{
          display: flex;
          align-items: center;
        }
        .description-mid {
          display: flex;
          align-items: flex-start;
        }
        &:nth-child(4) {
          margin-bottom: 0;
        }

      }
    }

    .footer-btns {
      text-align: center;
      margin-top: 30px;
      
      .artmisads-btn {
        min-width: 120px;
      }
    }

    .learn-more {
      text-align: center;

      a {
        font-size: 14px;
        color: var(--primary-color);
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>